import React, { useState, useRef } from 'react';
import axios from 'axios';

const Dashboard = () => {
  const [candidateFile, setCandidateFile] = useState(null);
  const [jobFile, setJobFile] = useState(null);
  const [uploadingCandidate, setUploadingCandidate] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadingJob, setUploadingJob] = useState(false);


  const candidateInputRef = useRef(null);
  const jobInputRef = useRef(null);

  const handleCandidateFileChange = (e) => setCandidateFile(e.target.files[0]);
  const handleJobFileChange = (e) => setJobFile(e.target.files[0]);



  const handleCandidateUpload = async () => {
    if (!candidateFile) return alert('Please select a candidate file.');

    const formData = new FormData();
    formData.append('file', candidateFile);

    const token = localStorage.getItem('token');

    setUploadingCandidate(true);
    setUploadProgress(0);

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/bulkcandidate/upload-excel`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
          timeout: 30 * 60 * 1000, // 30 minutes timeout
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setUploadProgress(percentCompleted);
          }
        }
      );

      alert('Candidate Excel uploaded successfully!');
      setCandidateFile(null);
      setUploadProgress(0);
      if (candidateInputRef.current) candidateInputRef.current.value = null;
    } catch (error) {
      console.error('Candidate upload failed:', error.response?.data || error.message);
      alert('Failed to upload candidate Excel. ' + (error.response?.data?.message || ''));
    }
    setUploadingCandidate(false);
    setUploadProgress(0);
  };

  const handleJobUpload = async () => {
    if (!jobFile) return alert('Please select a job file.');

    const formData = new FormData();
    formData.append('file', jobFile);

    const token = localStorage.getItem('token');

    setUploadingJob(true);

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/bulkRequirement/upload-jobexcel`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );

      alert('Job Excel uploaded successfully!');
      setJobFile(null);
      if (jobInputRef.current) jobInputRef.current.value = null;
    } catch (error) {
      console.error('Job upload failed:', error.response?.data || error.message);
      alert('Failed to upload job Excel.');
    }
    setUploadingJob(false);
  };

  return (
    <div className="p-6">
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {/* Candidate Upload */}
        <div className="p-6 bg-white rounded-lg shadow">
          <h2 className="mb-4 text-lg font-semibold">Upload Candidates Excel</h2>
          <input
            ref={candidateInputRef}
            type="file"
            accept=".xlsx, .xls"
            onChange={handleCandidateFileChange}
            className="block w-full px-3 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button
            onClick={handleCandidateUpload}
            disabled={uploadingCandidate}
            className={`w-full px-4 py-2 text-white rounded ${uploadingCandidate ? 'bg-blue-300 cursor-not-allowed' : 'bg-blue-500 hover:bg-blue-600'
              }`}
          >
            {uploadingCandidate ? (uploadProgress === 100 ? 'Processing...' : `Uploading ${uploadProgress}%`) : 'Upload Candidates Excel'}
          </button>

          {uploadingCandidate && (
            <div className="w-full bg-gray-200 rounded-full h-2.5 mt-4">
              <div
                className="bg-blue-600 h-2.5 rounded-full transition-all duration-300"
                style={{ width: `${uploadProgress}%` }}
              ></div>
              {uploadProgress === 100 && <p className="text-xs text-gray-500 mt-2 text-center">Processing large file, please wait...</p>}
            </div>
          )}
        </div>

        {/* Job Upload */}
        <div className="p-6 bg-white rounded-lg shadow">
          <h2 className="mb-4 text-lg font-semibold">Upload Jobs Excel</h2>
          <input
            ref={jobInputRef}
            type="file"
            accept=".xlsx, .xls"
            onChange={handleJobFileChange}
            className="block w-full px-3 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
          <button
            onClick={handleJobUpload}
            disabled={uploadingJob}
            className={`w-full px-4 py-2 text-white rounded ${uploadingJob ? 'bg-purple-300 cursor-not-allowed' : 'bg-purple-500 hover:bg-purple-600'
              }`}
          >
            {uploadingJob ? 'Uploading...' : 'Upload Jobs Excel'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
